<template>
  <div class="nnform-element-container">
    <div class="checkout-profile">
      <div class="checkout-profile-avatar-wrapper">
        <img class="checkout-profile-avatar" v-if="user.avatar.src" :src="user.avatar.src">
        <img class="checkout-profile-avatar" v-else src="/assets/images/checkout/avatar.svg">
      </div>

      <div class="checkout-profile-info">
        <div class="checkout-profile-info__name">{{ user.name }}</div>

        <div class="checkout-profile-info-contact">

          <div class="checkout-profile-info__phone" v-if="user.phone">{{ user.phone }}</div>
          <div class="checkout-profile-info__phone wrong" v-else>Телефон: Не указан! (<a href="/profile/settings/">УКАЗАТЬ</a> )</div>

          <div class="checkout-profile-info__email">{{ user.email }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutProfile",
  props: {
    user: Object,
  },
}
</script>

<style scoped>

</style>